<div class="label-wrap">
  <label
    fd-form-label
    [for]="for"
    [required]="required"
    class="label-item"
    [title]="tooltip || ''"
    >{{ label }}</label
  >
  @if (!!popoverBody) {
    <span>
      <app-help-popover
        [headerTitle]="popoverTitle"
        [body]="popoverBody"
        [width]="width"
        [placement]="popoverPlacement"
        [enabled]="enabled"
        class="popover-button"
      ></app-help-popover>
    </span>
  }
</div>
